// 등급(plan_tier) 판정 — 요금제 4종 개편의 단일 tier 판정 지점.
//
// ⚠️ 이 파일은 의존성 zero 로 유지할 것 — config/feature-flags 가 이 파일을 import 하므로
// featureFlags·redux·conf·i18n 을 여기서 import 하면 순환 참조나 무거운 import 체인이 생기고,
// conf.js 의 window 의존성이 node 환경 jest 를 깨뜨린다(docs/wiki testing 룰).
// 대신 redux saga(user/sagas.js)가 로그인·워크스페이스 선택 시점에 컨텍스트를 주입한다.

let planContext = null

/**
 * saga 가 주입하는 게이팅 컨텍스트.
 * @param {{ isGlobal: boolean, license: object|null } | null} context
 *   license = GET /v1/workspaces/license 응답 data (redux paidLicense 와 동일 객체)
 */
export const setPlanContext = (context) => {
  planContext = context || null
}

/** 서버가 산출한 license 객체 (미주입·로그아웃 시 null) — 용량 상한 소비처용 */
export const getPlanLicense = () => (planContext && planContext.license) || null

/**
 * 현재 워크스페이스가 Professional 등급 기능을 쓸 수 있는가.
 *
 * 판정 규칙 (분석 문서 §4.1·§7.2·§7.5, 기획 확정 2026-08-21, 글로벌 적용 2026-08-27):
 * - 한국향(KR) 또는 컨텍스트 미주입 = 항상 true — 개편은 글로벌향(일본·미국) 한정.
 *   KR 을 포함시키면 plan_tier 가 항상 NULL 이라 "NULL = Basic" 해석에 걸려
 *   기존 TOTP·SSO 가 통째로 꺼진다 — isGlobal() 경계를 반드시 유지할 것.
 * - license 부재(조회 실패·미로드) = true — fail-open (일시 장애를 기능 상실로 보이지 않게)
 * - 서버가 등급 게이팅을 강제한다고 명시하지 않은 상태(plan_tier_enforced !== true) = true —
 *   킬스위치는 서버·화면이 같은 스위치를 봐야 한다. 이게 없으면 JP_PLAN_TIER_ENFORCE=false
 *   인데도 plan_tier NULL 인 유료 고객이 화면에서만 Basic 이 된다(백필 전 프론트 배포 사고).
 *   ⚠️ `=== false` 가 아니라 `!== true` 여야 한다 — plan_tier·plan_tier_enforced 는 이번
 *   개편에서 신설된 필드라 **구버전 백엔드는 둘 다 안 내려준다**. `=== false` 로 두면
 *   undefined 가 통과하지 못하고 아래 plan_tier 비교까지 흘러 false 가 되어, 프론트가
 *   백엔드보다 먼저 뜬 구간(dev 는 두 배포가 동시 트리거)에 JP 고객 전원이 Professional
 *   이어도 TOTP 생성·SSO 탭이 잠긴다. 새 백엔드는 항상 bool 을 내려주므로(workspace_
 *   license_service.py) 집행 동작은 달라지지 않는다.
 * - 체험판(plan_type TRIAL) = true — PRO 동급
 * - 그 외 = plan_tier === 'PROFESSIONAL' (글로벌향에서 NULL = Basic 취급)
 *
 * @returns {boolean}
 */
const hasProFeature = () => {
  if (!planContext || planContext.isGlobal !== true) return true
  const { license } = planContext
  if (!license) return true
  if (license.plan_tier_enforced !== true) return true
  if (license.plan_type === 'TRIAL') return true
  return license.plan_tier === 'PROFESSIONAL'
}

export default hasProFeature
